import { alpha } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { isDark } from '../../../global/styles';

export const NO_SELECT_CLASS = 'no-select';
export const DISABLED_CLASS = 'is-disabled';
export const COMPACT_CLASS = 'compact';

export const TaskBannerContainer = styled('div')(({ theme }) => ({
  flex: 'auto',
  width: '100%',
  minWidth: 0,
  backgroundColor: alpha(theme.palette.primary.main, 0.25),
  '@media print': {
    display: 'none',
  },
  [`&.${NO_SELECT_CLASS}`]: {
    backgroundColor: isDark(theme) ? alpha(theme.palette.common.black, 0.15) : alpha(theme.palette.common.white, 0.15),
  },
  [`&.${DISABLED_CLASS}`]: {
    color: alpha(theme.palette.text.secondary, 0.5),
  },
}));

export const InnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  height: 74,
  minHeight: 74,
  [`&.${COMPACT_CLASS}`]: {
    height: 'auto',
    minHeight: 'unset',
    gap: theme.spacing(1),
  },
}));

export const BannerScroll = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  overflowX: 'auto',
  overflowY: 'hidden',
  WebkitOverflowScrolling: 'touch',
  overscrollBehaviorX: 'contain',
});

export const AddButton = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));
